import React from 'react';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Alarm from '@material-ui/icons/Alarm';
import Email from '@material-ui/icons/Email';
import Send from '@material-ui/icons/Send';
import Code from '@material-ui/icons/Code';
import Link from '@material-ui/icons/Link';
import LocalMovies from '@material-ui/icons/LocalMovies';
import FileCopy from '@material-ui/icons/FileCopy';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Slider from '@material-ui/lab/Slider';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { isSafari } from "react-device-detect";
import TimerIcon from '@material-ui/icons/Timer';
import Utils from '../../Utils/Utils';
import Close from '@material-ui/icons/Close';

const styles = {
  divider: {
    paddingTop: 0,
    paddingBottom: 20
  }
}

class InputTime extends React.Component {

  hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  minutes = [];
  seconds = [];

  constructor(props) {
    super(props);
    for (var i = 0; i < 60; i++) {
      this.minutes.push(i)
      this.seconds.push(i)
    }
  }

  clean(v) {
    if (v < 10)
      return '0' + v;
    else
      return '' + v;
  }

  change = () => {
    let res;
    res = this.clean(this.hours[this.refs['hour'].selectedIndex]) + ':'
    res += this.clean(this.minutes[this.refs['minute'].selectedIndex]) + ':'
    res += this.clean(this.seconds[this.refs['second'].selectedIndex])
    this.props.onChange({
      target: {
        value: res
      }
    })
  }

  render() {
    let time = this.props.value.split(':')
    return (
      <div className="ios_time">
        <Typography>{ this.props.label }</Typography>
        <select ref="hour" onChange={this.change}>
          { this.hours.map((hour, index) => {
            let selected = false;
            if(time[0] == this.clean(hour))
              selected = true;
            return (
              <option selected={ selected } key={ index }>{ this.clean(hour) }</option>
            );
          })}
        </select>
          :
        <select ref="minute" onChange={this.change}>
          { this.minutes.map((minute, index) => {
            let selected = false;
            if(time[1] == this.clean(minute))
              selected = true;
            return (
              <option selected={ selected } key={ index }>{ this.clean(minute) }</option>
            );
          })}
        </select>
          :
        <select ref="second" onChange={this.change}>
          { this.seconds.map((second, index) => {
          let selected = false;
            if(time[2] == this.clean(second))
              selected = true;
            return (
              <option selected={ selected } key={ index }>{ this.clean(second) }</option>
            );
          })}
        </select>
      </div>
    )
  }
}

export default class Extract extends React.Component {
  
  colors = {
    text: window.theme.palette.background.txt || '#333333',
    background: window.theme.palette.background.paper,
    primary: window.theme.palette.primary.main,
    secondary: window.theme.palette.secondary.main,
  };

  state = {
    show: true,
    start: '00:00:00',
    end: '00:00:00',
    value: 50,
    width: 640,
    odj: false,
    odjLink: false,
    responsive: false,
    justAudio: false,
    linkCopied: 'Cliquer sur le champ pour copier le texte',
    iframeCopied: 'Cliquer sur le champ pour copier le texte',
    alertMail: false
  }
  
  listeners = [];

  params;
  
  componentDidMount() {
	this.listeners.push(window.sdk.on('seeked', () => {
		this.show(true);	
	}));
  }
  
  componentWillUnmount() {
    for (var i in this.listeners) {
      this.listeners[i]();
    } 
  }

  show(value, index = -1) {

    if (value) {
    
      if (index == -1)
        this.chapter = window.sdk.getCurrentChapter();
      else
        this.chapter = window.sdk.getChapter(index);
	
	  if(window.live && index == -1) {		
		let speakerChapter = window.sdk.live.getCurrentCue('speaker');
		let el = document.querySelector('.chapter-current.chapter_speaker_item #progress-container');  		
		if(speakerChapter && el) {
			this.chapter = speakerChapter;
		}
	  }

      //console.log(this.chapter);

      let start = window.sdk.player().getCurrentTime() - 30;
      if(start < 0)
        start = 0
      start = this.getDateFromSecond(start);
      let end = this.getDateFromSecond(window.sdk.player().getCurrentTime() + 30);
      if(this.chapter) {
        start = this.getDateFromSecond(this.chapter.start_second);
        end = this.getDateFromSecond(this.chapter.start_second + this.chapter.duration);
      }
	  
	  
      
      
      let showTimer = true;
      if(window.query && window.query.s) {
        start = window.query.s;
        end = window.query.e;
        showTimer = false;
      }
      
      this.iframeTpl = '<iframe width="%w" height="%h" style="%s" src="' + document.location.href.split('?').shift() + '%p"></iframe>';
      
      this.setState({
        show: value,
        start: start,
        end: end,
        link: document.location.href.split('?').shift(),
        alertMail: false,
        showTimer: showTimer
      });
      
    }
    else {
      this.setState({
        show: value
      });
    }

  }

  onChangeStart = async(e) => {
    await this.setState({
      start: e.target.value
    })
    /*if (this.hmsToSeconds(this.state.end) < this.hmsToSeconds(this.state.start)) {
      this.setState({
        end: this.getDateFromSecond(this.hmsToSeconds(this.state.start) + 60)
      })
    }*/
  }

  onChangeEnd = async(e) => {
    await this.setState({
      end: e.target.value
    })
    /*if (this.hmsToSeconds(this.state.end) > window.sdk.player().getTotalDuration()) {
      this.setState({
        end: this.getDateFromSecond(window.sdk.player().getTotalDuration())
      })
    }
    if (this.hmsToSeconds(this.state.end) < this.hmsToSeconds(this.state.start)) {
      this.setState({
        start: this.getDateFromSecond(this.hmsToSeconds(this.state.end) - 60)
      })
    }*/
  }

  captureStart = () => {
    let s = Math.round(window.sdk.player().getCurrentTime());
    s = this.getDateFromSecond(s);
    this.setState({
      start: s
    })
  }

  captureEnd = () => {
    let s = Math.round(window.sdk.player().getCurrentTime());
    s = this.getDateFromSecond(s);
    this.setState({
      end: s
    })
  }

  getDateFromSecond(second) {
    let date = new Date(null);
    date.setSeconds(second);
    return date.toISOString().substr(11, 8);
  }

  hmsToSeconds(str) {
    if(str.length == 5)
      str += ':00'
    if(str.length == 2)
      str += ':00:00'
    var p = str.split(':'),
      s = 0,
      m = 1;

    while (p.length > 0) {
      s += m * parseInt(p.pop(), 10);
      m *= 60;
    }

    return s;
  }

  sliderChange = (event, value) => {
    let v = Math.round(value * 9 + 200);

    this.setState({
      value: value,
      width: v
    })
  }

  handleCheckODJ = (e) => {
    this.setState({
      odj: e.target.checked
    });
  }

  handleCheckODJLink = (e) => {
    this.setState({
      odjLink: e.target.checked
    });
  }

  handleCheckResponsive = (e) => {
    this.setState({
      responsive: e.target.checked
    });
  }

  handleCheckAudio = (e) => {
    this.setState({
      justAudio: e.target.checked
    });
  }
  
  copyIframe2 = () => {
    document.getElementById('iframe_input').select();
    try {
      var successful = document.execCommand('copy');
      this.setState({
        iframeCopied: 'Copié dans le presse papier'
      })
    }
    catch (err) {
      console.log('copy fail')
    }
  }
  
  copyLink2 = () => {
    document.getElementById('link_input').select();
    try {
      var successful = document.execCommand('copy');
      this.setState({
        linkCopied: 'Copié dans le presse papier'
      })
    }
    catch (err) {
      console.log('copy fail')
    }
  }

  copyIframe = () => {
    this.copy(document.getElementById('iframe_input'));
    this.setState({
      iframeCopied: 'Copié dans le presse papier'
    })
  }

  copyLink = () => {
    this.copy(document.getElementById('link_input'));
    this.setState({
      linkCopied: 'Copié dans le presse papier'
    })
  }
  
  copy(el) {
    var oldContentEditable = el.contentEditable,
      oldReadOnly = el.readOnly,
      range = document.createRange();

    el.contentEditable = true;
    el.readOnly = false;
    range.selectNodeContents(el);

    var s = window.getSelection();
    s.removeAllRanges();
    s.addRange(range);

    el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

    el.contentEditable = oldContentEditable;
    el.readOnly = oldReadOnly;

    document.execCommand('copy');
  }


  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  sendExtractByMail = () => {
    
    console.log(this.state.start, this.state.end)
    
    let start = this.hmsToSeconds(this.state.start);
    let end = this.hmsToSeconds(this.state.end);
    
    console.log(start, end)
    
    if(end <= start) {
      
      this.setState({
        dialogTitle: 'Timecode non correct',
        dialogDescription: 'Attention le timecode de fin de votre extrait semble inférieur au timecode de début',
        alertMail: true
      })
      return;
      
    }
    
    if (!this.validateEmail(this.state.email)) {
      this.setState({
        dialogTitle: 'Email non correct',
        dialogDescription: 'Merci de modifier l\'email',
        alertMail: true
      })
      return;
    }
    
    
    
    window.sdk.sendExtractByMail(this.hmsToSeconds(this.state.start), this.hmsToSeconds(this.state.end), this.state.email, this.state.justAudio);
    this.setState({
      dialogTitle: 'Extrait en cours de génération',
      dialogDescription: 'Un email vous sera envoyé dès que la vidéo sera prête',
      alertMail: true,
      email: ''
    })
      
  }

  changeEmail = (e) => {
    
    this.setState({
      email: e.target.value
    })
  }
  
  keyEmail = (e) => {
    if (e.key === 'Enter') {
      this.sendExtractByMail()
      return;
    }
  }

  handleClose = () => {
    this.setState({ alertMail: false });
  };

  alertMail() {
    return (
      <Dialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.alertMail}
        >
        <DialogTitle><span style={{ color: this.colors.text }}>{this.state.dialogTitle}</span></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ color: this.colors.text }}>{this.state.dialogDescription}</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { value, responsive } = this.state;


    this.paramsLink = this.params = '?v4=1&s=' + this.hmsToSeconds(this.state.start) + '&e=' + this.hmsToSeconds(this.state.end);
    if (!this.state.odj) {
      this.params += '&odj=hide';
    }
    if (!this.state.odjLink) {
      this.paramsLink += '&odj=hide';
    }

    //console.log(this.params);

    if (this.iframeTpl) {
      this.iframe = this.iframeTpl;
	  
	  let height = 780;
	  if(!this.state.odj)
		height = 360;

      this.iframe = this.iframe.replace('%w', responsive ? '100%' : this.state.width);
      this.iframe = this.iframe.replace('%h', responsive ? '100%' : height);
      this.iframe = this.iframe.replace('%s', responsive ? 'position:absolute;top:0;left:0;width:100%;height:100%;' : '');
      this.iframe = this.iframe.replace('%p', this.params);
      if (responsive) {
        this.iframe = '<div style="padding:56.25% 0 0 0;position:relative;">' + this.iframe + '</div>';
      }
    }
    
    
    let customCss = `.extract .checkbox--lighted:not(.checkbox--checked) svg { color: ${ this.colors.text } } .extract hr { background-color: ${ this.colors.primary } }`;
    
    if (window.sdk.isExtended()) {
      customCss += ` .extract { border: 0px solid ${this.colors.primary} }`;
    }

    return (
      <Grid container direction="row" style={{ alignItems: 'center' }} className={ ((!this.state.show) ? 'hide ' : '') + 'extract tab-extract-block' }>
      
        { window.sdk.isOverlay() && <div className="tabs-overlay__close" onClick={(e) => { window.sdk.emit('closeTabs') }}>
          <Close style={{ color: window.theme.palette.background.txt }} /> 
        </div> }
      
        <style dangerouslySetInnerHTML={{__html: customCss}} />
      
        { this.alertMail() }
        
        {/* BEGIN Title */}
        <Grid item xs={12} className={'extract__title'} style={{ paddingBottom: 16 }}>
          <Typography variant={'h6'} noWrap={true} style={{ alignItems: 'center', display: 'flex' }}>
            <TimerIcon style={{ color: this.colors.text, marginRight: '5px' }} />
            <span style={{ color: this.colors.text }}>{ 'Création d\'extrait' }</span>
            {window.sdk.isExtended() && <div className='extract__titlesub' style={{ backgroundColor: this.colors.primary }}></div>}
          </Typography>
        </Grid>
        {/* END Title */}
        
        <Grid item xs={12}>
          { !isSafari && this.state.showTimer &&
            <Grid item xs={window.sdk.isOverlay() ? 12 : 12} className={'center'}>
              <div className="timeinput-wrapper" style={{ display: 'flex', flexWrap: 'nowrap' }}>
                <TextField
                  label="Démarrer à"
                  type="time"
                  value={ this.state.start }
                  onChange={ this.onChangeStart }
                  className="timeinput-wrapper__inner"
                  style={{
                    flex: '1 1 auto',
                    borderColor: Utils.hexToRGB(this.colors.text, 0.5),
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      color: Utils.hexToRGB(this.colors.text, 0.7),
                    }
                  }}
                  InputProps={{
                    className: "Input-time",
                    style: {
                      color: this.colors.text
                    },
                  }}
                  inputProps={{
                    step: 1, // 5 min
                    style: {
                      color: this.colors.text,
                    }
                  }}
                />
                
                {/*
                <IconButton onClick={ this.captureStart } color="primary"  aria-label="Add an alarm">
                  <Alarm style={{ color: this.colors.text }} />
                </IconButton>
                */}
              </div>
            </Grid>
          }
          
          { isSafari && this.state.showTimer &&
            <Grid item xs={12} className={'center'}>
            
              <InputTime label="Démarrer à" value={ this.state.start } onChange={ this.onChangeStart } />
           
              <IconButton onClick={ this.captureStart } color="primary"  aria-label="Add an alarm">
                <Alarm style={{ color: this.colors.text }} />
              </IconButton>
            </Grid>
          }
          
          { !isSafari && this.state.showTimer &&
            <Grid item xs={window.sdk.isOverlay() ? 12 : 12} className={'center'} >
              <div className="timeinput-wrapper" style={{ display: 'flex', flexWrap: 'nowrap' }}>
                <TextField
                  label="Terminer à"
                  type="time"
                  value={ this.state.end }
                  onChange={ this.onChangeEnd }
                  className="timeinput-wrapper__inner"
                  style={{
                    flex: '1 1 auto',
                    borderColor: Utils.hexToRGB(this.colors.text, 0.5),
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      color: Utils.hexToRGB(this.colors.text, 0.7),
                    }
                  }}
                  InputProps={{
                    className: "Input-time",
                    style: {
                      color: this.colors.text
                    },
                  }}
                  inputProps={{
                    step: 1, // 5 min
                    style: {
                      color: this.colors.text,
                    }
                  }}
                />
             
                {/*
                <IconButton onClick={ this.captureEnd } color="primary"  aria-label="Add an alarm">
                  <Alarm style={{ color: this.colors.text }} />
                </IconButton>
                */}
              </div>
            </Grid>
          }
          
          { isSafari && this.state.showTimer &&
            <Grid item xs={12} className={'center'}>
            
              <InputTime label="Terminer à" value={ this.state.end } onChange={ this.onChangeEnd } />
           
              <IconButton onClick={ this.captureEnd } color="primary"  aria-label="Add an alarm">
                <Alarm />
              </IconButton>
            </Grid>
          }
        </Grid>
        
        
        <Grid item xs={12} className={'center'} style={ styles.divider }>
          <Divider />
        </Grid>
        
        
        {/* Begin iFrame */}
        <Grid item xs={12}>
          <Typography className="group-copy__title">
            <Code style={{ color: this.colors.text, marginRight: '5px', verticalAlign: 'middle' }} />
            <span style={{ color: this.colors.text, verticalAlign: 'middle' }}>Intégrer l'extrait vidéo sur votre site</span>
          </Typography>
          
        
          {/* BEGIN Options */}
          <Grid container>
            <Grid item xs={6} className={'align-left'}>
                <FormControlLabel
                  className='extract-checkbox'
                  control={
                    <Checkbox
                      checked={this.state.odj}
                      onChange={this.handleCheckODJ}
                      color="primary"
                      classes={{ root: 'checkbox--lighted', checked: 'checkbox--checked' }}
                    />
                  }
                  label={<Typography style={{ color: this.colors.text }}>Avec ordre du jour</Typography>}
                />
            </Grid>
            
            <Grid item xs={6} className={'align-left'}>
                <FormControlLabel
                  className='extract-checkbox'
                  control={
                    <Checkbox
                      checked={this.state.responsive}
                      onChange={this.handleCheckResponsive}
                      color="primary"
                      classes={{ root: 'checkbox--lighted', checked: 'checkbox--checked' }}
                    />
                  }
                  label={<Typography style={{ color: this.colors.text }}>Responsive</Typography>}
                />
            </Grid>
          </Grid>
          {/* END Options */}
          
          <div className="group-copy">
            {/*id="standard-full-width"*/}
            <TextField
              value={ this.iframe }
              helperTextOld={ <span style={{ color: Utils.hexToRGB(this.colors.text, 0.7) }}>{ this.state.iframeCopied }</span> }
              onClick={ this.copyIframe }
              id="iframe_input"
              fullWidth
              margin="normal"
              multiline={ true }
              rowsMax={ 4 }
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                style: { color: this.colors.text, borderColor: Utils.hexToRGB(this.colors.text, 0.5), borderWidth: 0 },
                className: "custom-input"
              }}
            />
            
            <div className="group-copy__button" onClick={ this.copyIframe } style={{ color: this.colors.primary }}>
              <Typography noWrap style={{ color: 'inherit', lineHight: 1, margin: 0, fontSize: '0.75rem' }}>
                <FileCopy style={{ color: this.colors.primary, verticalAlign: 'middle', marginRight: '5px', fontSize: '0.75rem' }} />
              </Typography>
            </div>
          </div>
        </Grid>
        {/* END iFrame */}
        
        
        <Grid item xs={12} className={'center'} style={ styles.divider }>
          <Divider />
        </Grid>
        
        
        {/* BEGIN Link */}
        <Grid item xs={12}>
          <div className="group-copy">
            <Typography className="group-copy__title">
              <Link style={{ color: this.colors.text, marginRight: '5px', verticalAlign: 'middle' }} />
              <span style={{ color: this.colors.text, verticalAlign: 'middle' }}>Partager le lien permanent de cette vidéo</span>
            </Typography>
            
            <Grid container>
              <Grid item xs={6} className={'align-left'}>
                  <FormControlLabel
                    className='extract-checkbox'
                    control={
                      <Checkbox
                        checked={this.state.odjLink}
                        onChange={this.handleCheckODJLink}
                        color="primary"
                        classes={{ root: 'checkbox--lighted', checked: 'checkbox--checked' }}
                      />
                    }
                    label={<Typography style={{ color: this.colors.text }}>Avec ordre du jour</Typography>}
                  />
              </Grid>
            </Grid>
          
            {/*id="standard-full-width"*/}
            <TextField
              value={ this.state.link + this.paramsLink}
              helperTextOld={ <span style={{ color: Utils.hexToRGB(this.colors.text, 0.7) }}>{ this.state.linkCopied }</span> }
              onClick={ this.copyLink }
              id="link_input"
              fullWidth
              margin="normal"
              multiline={ true }
              rowsMax={ 4 }
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                style: { color: this.colors.text, borderColor: Utils.hexToRGB(this.colors.text, 0.5), borderWidth: 0 },
                className: "custom-input"
              }}
            />
            
            <div className="group-copy__button" onClick={ this.copyLink2 } style={{ color: this.colors.primary }}>
              <Typography noWrap style={{ color: 'inherit', lineHight: 1, margin: 0, fontSize: '0.75rem' }}>
                <FileCopy style={{ color: this.colors.primary, verticalAlign: 'middle', marginRight: '5px', fontSize: '0.75rem' }} />
              </Typography>
            </div>
          </div>
        </Grid>
        {/* END Link */}
        
        
        <Grid item xs={12} className={'center'} style={ styles.divider }>
          <Divider />
        </Grid>
        
        
        {/* BEGIN Mail */}
        <Grid item xs={12}>
          
          <div className="group-copy group-copy--email" style={{ marginBottom: 10 }}>
            <Typography className="group-copy__title">
              <LocalMovies style={{ color: this.colors.text, marginRight: '5px', verticalAlign: 'middle' }} />
              <span style={{ color: this.colors.text, verticalAlign: 'middle' }}>Recevoir par mail le lien de l'extrait vidéo</span>
            </Typography>
            
            <FormControlLabel
              className='extract-checkbox'
              control={
                <Checkbox
                  checked={ this.state.justAudio }
                  onChange={ this.handleCheckAudio }
                  color="primary"
                  classes={{ root: 'checkbox--lighted', checked: 'checkbox--checked' }}
                />
              }
              label={<Typography style={{ color: this.colors.text }}>Audio uniquement</Typography>}
           />
          
            {/*id="standard-full-width"*/}
            <TextField
              id="input-with-icon-grid" 
              fullWidth 
              label="Saisissez votre email" 
              placeholder="email@email.com"
              value={ this.state.email }
              onKeyPress={this.keyEmail}
              onChange={ this.changeEmail }
              InputLabelProps={{
                style: { color: this.colors.text, marginTop: 10 },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email />
                  </InputAdornment>
                ),
                style: { color: this.colors.text, borderColor: Utils.hexToRGB(this.colors.text, 0.5), marginTop: 30 },
                className: "custom-input"
              }}
            />
            
            <Button onClick={ this.sendExtractByMail } className="group-copy__button" color="primary" aria-label="Add" style={{ color: this.colors.primary }}>
              <Send />
            </Button>
			
			
          </div>
			<Typography>
				L’extrait mp4 ou mp3 reste disponible <b>une heure</b> après avoir été généré.<br />
				L’email sera automatiquement supprimé au bout de <b>24h</b>.
			</Typography>
        </Grid>
        {/* END Mail */}
        
      </Grid >
    );
  }

}



// WEBPACK FOOTER //
// ./src/Player/Tabs/Extract.js